import { useEffect, useState } from 'react';
import { headingSlug } from '../../lib/toc';

interface TocItem {
  id: string;
  text: string;
  level: 2 | 3;
}

export function TableOfContents({ contentId, articleKey }: { contentId: string; articleKey: string }) {
  const [items, setItems] = useState<TocItem[]>([]);

  useEffect(() => {
    const root = document.getElementById(contentId);
    if (!root) return;

    const seen = new Map<string, number>();
    const nextItems = Array.from(root.querySelectorAll<HTMLHeadingElement>('h2, h3')).map((heading) => {
      const text = heading.textContent?.trim() ?? '';
      const base = heading.id || headingSlug(text) || 'secao';
      const count = seen.get(base) ?? 0;
      seen.set(base, count + 1);
      const id = count === 0 ? base : `${base}-${count + 1}`;
      heading.id = id;
      return { id, text, level: heading.tagName === 'H3' ? 3 : 2 } as TocItem;
    }).filter((item) => item.text);

    setItems(nextItems);
  }, [contentId, articleKey]);

  if (!items.length) return null;

  return (
    <nav className="table-of-contents" aria-label="Nesta página">
      <strong>Nesta página</strong>
      <ul>
        {items.map((item) => (
          <li key={item.id} className={item.level === 3 ? 'toc-level-3' : undefined}>
            <a href={`#${item.id}`}>{item.text}</a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
